import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/attach_plan_to_plan_wizard/AddExistingPlanForm.scss';
import Button from '../../components/Button';
import { __, transformToListPairs } from '../../core/utils';
import Select from '../../components/Select';
import ButtonGroup from '../../components/ButtonGroup';

const AddExistingPlanForm = ({
  handleSubmit,
  possiblePlans,
  submitting,
  onClose,
}) => {
  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='plan_id'
          searchable
          component={Select}
          label={__('table.columns.choose-existing-plan')}
          options={transformToListPairs(possiblePlans, 'title')}
        />
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={onClose}
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              submit
              middleText={__('button.attach')}
              spinning={submitting}
            />
          </ButtonGroup>
        </div>
      </div>
    </Form>
  );
};

export default reduxForm({
  form: 'attach_plan_to_plan_wizard.add_existing_plan_form',
})(AddExistingPlanForm);
